export default function LocalIntro() {
  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-plum-dark mb-6 md:mb-8">
            Votre réparateur de fenêtre à Bischwiller
          </h2>
          <div className="space-y-5 text-plum-dark text-base md:text-lg leading-relaxed">
            <p>
              Bischwiller, entre forêt et champs, est une ville résidentielle où les lotissements pavillonnaires côtoient les maisons de ville. Les fenêtres y vieillissent au rythme des saisons alsaciennes. Nous réparons le mécanisme chez vous, pièce comprise, déplacement gratuit.
            </p>
            <p>
              Bischwiller, au nord de l'agglomération, est une ville résidentielle calme où les lotissements pavillonnaires dominent. Les fenêtres y vieillissent au rythme des saisons, entre le bois des maisons anciennes et le PVC des constructions récentes. Nous connaissons bien cette commune et intervenons chez vous pour réparer le mécanisme.
            </p>
            <p>
              Notre atelier de Strasbourg est à une vingtaine de minutes. Le déplacement est gratuit, le diagnostic est gratuit, la pièce de remplacement est comprise et chaque réparation est garantie 10 ans. Nos techniciens connaissent le parc immobilier local, des quartiers pavillonnaires aux centres-bourgs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}